import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { colors } from "../../../theme/theme";

export const AddressFieldsGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(2),
  width: "100%",
  "& > *": {
    flex: "1 1 calc(33.333% - 11px)",
    minWidth: "220px",
  },
}));

export const CountrySelect = styled("select")({
  width: "100%",
  padding: "10px 14px",
  borderRadius: "14px",
  border: "1px solid rgba(73,42,24, 0.2)",
  fontSize: "14px",
  color: colors.primary,
  fontFamily: "'Quicksand', sans-serif",
  backgroundColor: "transparent",
});
